module.exports = __webpack_public_path__ + "img/postgresql.85163bed.png";